import logoImg from '../assets/icon-logo.svg';
import previewImg from "../assets/icon-preview.svg";
import {ReactComponent as ReactLinkedinSvg} from '../assets/icon-linkedin.svg';
import {ReactComponent as ReactFacebookSvg} from '../assets/icon-facebook.svg';
import {ReactComponent as ReactTwitterSvg} from '../assets/icon-twitter.svg';

function TechnicalMode({message}) {
    return (
        <section className="autorization__section">
            <header className="autorization__header">
                <img className="autorization__logo-image" src={logoImg} width="330" height="auto"
                     alt="Information Consultants"/>
                <h1 className="visually-hidden">Welcome to Information Consultants website</h1>
            </header>

            <div className="autorization__login-container">
                <img className="autorization__preview-image" src={previewImg} width="645" height="auto" loading="lazy"
                     alt="form preview"/>

                <form className="autorization__form">
                    <h2>{message}</h2>

                    <div className="autorization__social-container">
                        <h3>Connect with ICON!</h3>
                        <ul className="autorization__social-list">
                            <li className="autorization__social-item">
                                <a className="autorization__social-link"
                                   href="https://www.linkedin.com/company/icon-information-consultants/" rel="noreferrer"
                                   target="_blank">
                                    <ReactLinkedinSvg className="autorization__social-svg"/>
                                    <span>Linkedin link</span>
                                </a>
                            </li>
                            <li className="autorization__social-item">
                                <a className="autorization__social-link" href="https://www.facebook.com/ICONInformationConsultants"
                                   rel="noreferrer" target="_blank">
                                    <ReactFacebookSvg className="autorization__social-svg"/>
                                    <span>Facebook link</span>
                                </a>
                            </li>
                            <li className="autorization__social-item">
                                <a className="autorization__social-link" href="https://www.facebook.com/ICONInformationConsultants"
                                   rel="noreferrer" target="_blank">
                                    <ReactTwitterSvg className="autorization__social-svg"/>
                                    <span>Facebook link</span>
                                </a>
                            </li>
                        </ul>
                    </div>
                </form>
            </div>
        </section>
    )
}

export default TechnicalMode